export default __webpack_public_path__ + "assets/images/507-small.png";